import projectComponent from '../../Project';
import app from '$$app';
import globalStore from "$$globalStore";

function onProjectDeleted({ event, data: { project: { projectId } } }) {
  projectComponent.manualRemoveTeamProject(parseInt(projectId, 10));
  globalStore.commit('resourcesModel/removeAllResourcesFromProject', { projectId });
  globalStore.commit('tasksModel/deleteTasksByGanttId', projectId);

  const copiedTask = globalStore.getters['copyPaste/copiedTask'];

  if (copiedTask && +copiedTask.ganttId === +projectId) {
    globalStore.commit('copyPaste/setCopyPastError', 'can_not_copy_delete', { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event,
    projects: [projectId],
  });
}
export default onProjectDeleted;
